export function Logo({ className = '' }: { className?: string }) {
  return (
    <span
      className={`font-display font-extrabold uppercase tracking-tight ${className}`}
      aria-label="SneakGuessr"
    >
      Sneak<span className="text-accent">Guessr</span>
    </span>
  );
}
